import React from 'react'
import classNames from 'classnames'
import pretty from '@st-operations/uikit/lib/pretty'

import { useEventFeedsContext } from '../../../context/index.jsx'
import UnionSvg from './union.svg'
import CalendarSvg from './calendar.svg'

import './styles.scss'

const FREQUENCY_ONE_TIME_VALUE = 'one-time'

const FREQUENCY_DAILY_VALUE = 'daily'
const FREQUENCY_HOURLY_VALUE = 'hourly'
const FREQUENCY_MONTHLY_VALUE = 'monthly'
const FREQUENCY_LIVE_VALUES = [
  FREQUENCY_DAILY_VALUE,
  FREQUENCY_HOURLY_VALUE,
  FREQUENCY_MONTHLY_VALUE,
]

function convertDate(dateStr) {
  if (dateStr) {
    const symbolless = dateStr?.replace(/-/g, '')
    const year = symbolless.substring(0, 4)
    const month = symbolless.substring(4, 6)
    const day = symbolless.substring(6, 8)
    return `${year}-${month}-${day}`
  }

  return ''
}

const DeliveryStatus = ({ className }) => {
  const {
    data: { deliveries },
  } = useEventFeedsContext()
  const delivery = deliveries[0] ?? {}

  return (
    <div className={classNames('delivery-status', className)}>
      <div className="delivery-status__row">
        <Choose>
          <When condition={delivery.frequency === FREQUENCY_ONE_TIME_VALUE}>
            <UnionSvg style={{ marginRight: 10 }} />
          </When>
          <When condition={FREQUENCY_LIVE_VALUES.includes(delivery.frequency)}>
            <CalendarSvg style={{ marginRight: 10 }} />
          </When>
        </Choose>
        <div className="delivery-status__column">
          <div className="delivery-status__row">
            <Choose>
              <When condition={delivery.frequency === FREQUENCY_ONE_TIME_VALUE}>
                <span>
                  <span className="delivery-status__bold">One time </span>
                  <If condition={delivery.sampleStartDate}>
                    <span>{convertDate(delivery.sampleStartDate)}</span>
                    <If condition={delivery.sampleEndDate}>
                      <span>{' - '}</span>
                      <span>{convertDate(delivery.sampleEndDate)}</span>
                    </If>
                  </If>
                </span>
              </When>
              <When condition={delivery.frequency === FREQUENCY_DAILY_VALUE}>
                <span className="delivery-status__bold">Daily</span>
              </When>
              <When condition={delivery.frequency === FREQUENCY_HOURLY_VALUE}>
                <span className="delivery-status__bold">Hourly</span>
              </When>
              <When condition={delivery.frequency === FREQUENCY_MONTHLY_VALUE}>
                <span className="delivery-status__bold">Monthly</span>
              </When>
              <Otherwise>
                <span>{"You haven't added a delivery yet"}</span>
              </Otherwise>
            </Choose>
            <span className="delivery-status__spaced"> • </span>
            <span
              className={classNames(
                'delivery-status__badge',
                `delivery-status__badge--${delivery.status}`
              )}
            >
              {pretty(delivery.status)}
            </span>
          </div>
          <If condition={delivery.format || delivery.compression}>
            <div className="delivery-status__row">
              <span className="delivery-status__uppercase">{delivery.format}&nbsp;</span>
              <span className="delivery-status__uppercase">{delivery.compression}&nbsp;</span>
              <If condition={delivery.destination}>
                {' '}
                to {delivery.s3Bucket || delivery.destination}
              </If>
            </div>
          </If>
        </div>
      </div>
    </div>
  )
}

export default DeliveryStatus
